// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"3003fed5","79":"3206a520","111":"e37c651b","352":"e782c1f3","358":"3e03e64a","453":"c5338327"}[chunkId] + ".chunk.js";
};